import { TableCell } from "./TableCell";

export function TextPreviewCell({ value }) {
  return (
    <TableCell style={{ width: 120 }}>
      <div style={{ display: "flex" }}>{value !== "" ? value : ""}</div>
    </TableCell>
  );
}
